import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "col-span-4 uppercase text-gray-700 whitespace-nowrap text-xs pl-4" }
const _hoisted_2 = {
  key: 0,
  class: "col-span-2 uppercase text-gray-700 whitespace-nowrap text-xs text-center"
}
const _hoisted_3 = {
  key: 1,
  class: "col-span-3"
}


export default /*#__PURE__*/_defineComponent({
  __name: 'MarketsHeader',
  props: {
  isHero: Boolean
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["grid grid-cols-12", {
      'min-w-3xl lg:min-w-[912px]': !__props.isHero,
      'gap-4': __props.isHero
    }])
  }, [
    _createElementVNode("span", _hoisted_1, _toDisplayString(_ctx.$t('home.market')), 1),
    _createElementVNode("span", {
      class: _normalizeClass(["uppercase text-gray-700 whitespace-nowrap text-xs text-right", { 'col-span-2': !__props.isHero, 'col-span-3': __props.isHero }])
    }, _toDisplayString(_ctx.$t('home.lastPrice')), 3),
    _createElementVNode("span", {
      class: _normalizeClass(["uppercase text-gray-700 whitespace-nowrap text-xs col-span-2", { 'text-right': !__props.isHero }])
    }, _toDisplayString(_ctx.$t('home.change24h')), 3),
    (!__props.isHero)
      ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(_ctx.$t('home.sevenDaysPrice')), 1))
      : _createCommentVNode("", true),
    (!__props.isHero)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3))
      : _createCommentVNode("", true)
  ], 2))
}
}

})